export function pluralize(word, count) {
  return count >= 2 ? `${word}s` : word;
}

export function formatHoursAndMinutes(hoursDecimal) {
  const heures = Math.floor(hoursDecimal);
  const minutes = Math.round((hoursDecimal - heures) * 60);
  let result = '';
  if (heures > 0) result += `${heures} ${heures > 1 ? 'heures' : 'heure'}`;
  if (minutes > 0) result += (heures > 0 ? ' ' : '') + `${minutes} min`;
  if (!result) result = '0 heure';
  return result;
}

export function formatDays(hoursDecimal, dailyHours = 7) {
  const days = Math.floor(hoursDecimal / dailyHours);
  const reste = hoursDecimal % dailyHours;
  let result = '';
  if (days > 0) result += days;
  if (reste >= dailyHours / 2) result += (days > 0 ? '.5' : '0.5');
  if (!result) result = '0';
  return `${result} ${parseFloat(result) > 1 ? 'jours' : 'jour'}`;
}